/*
  Hard coded until Trade History REST provides an API
*/
const transactionEffects = [
    "B","S","F","I"
]

export const txEffectColumnDef = [
    {
      headerName: "Transaction Effect",
      field: "transcationEffect",
      suppressSizeToFit: false,
    },
  ];

  export default transactionEffects;